import * as React from 'react';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './sov-queries-input-filter.scss';

import type { TextEntry } from 'types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('modules/insights/sov/shared/sov-shared.i18n.json'));
applyTranslations(require('modules/insights/sov/components/queries/modals/sov-queries-modal.i18n.json'));

type Props = {
  value: string,
  onChange: (a: string) => void
};

const SHARED_MSG_KEY = 'sov_shared';
const MODAL_MSG_KEY = 'sov_queries_modal';

class SOVQueriesInputFilter extends React.PureComponent<Props> {
  handleChange = (event: SyntheticEvent<TextEntry>): void => {
    const { onChange } = this.props;
    const target = event.currentTarget;
    const value = (target.value || '').trim();

    onChange(value);
  };

  renderIcon(): React.ReactNode {
    const { value, onChange } = this.props;

    const iconClasses = classnames('sov-queries-input-filter__icon', {
      'sov-queries-input-filter__icon--is-visible': !isEmpty(value)
    });

    return (
      <div className={iconClasses}>
        <SVGDynamicIcon
          name="cross-custom-fg"
          customColor="grey"
          width={15}
          height={15}
          onClick={() => onChange('')}
        />
      </div>
    );
  }

  renderInput(): React.ReactNode {
    const { value } = this.props;

    return (
      <div className="sov-queries-input-filter__input">
        <Input
          width="responsive"
          value={value}
          placeholder={__t(`${MODAL_MSG_KEY}.placeholders.search_specific_channels`)}
          onChange={this.handleChange}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="sov-queries-input-filter">
        <FormField
          direction="column"
          label={__t(`${MODAL_MSG_KEY}.messages.select_channels`)}
          tooltipMessage={__t(`${SHARED_MSG_KEY}.tooltips.channels`)}
          tooltipWidth="extra-long"
          tooltipTextAlign="left"
          labelType="highlighted"
          fontSize="small"
          showValidationIcon={false}
          showRequiredMark
        >
          <div className="sov-queries-input-filter__contents">
            {this.renderInput()}
            {this.renderIcon()}
          </div>
        </FormField>
      </div>
    );
  }
}

export default SOVQueriesInputFilter;
